<template>
	<div class="opera-aversion" >
    <topNav :title="$t('Update_LOG')" url='/opera/version' replace="true"></topNav>
		<div class="title">
		</div>
		<div class="infoList">
      <ul class="tip">
                <li><h2>V1.0.0（2018-05-08）</h2></li>
                <li>1、MiHotel Opera版本隆重上线</li>
			</ul>
		</div>
	</div>
</template>
<script>
export default {
  data() {
    return {};
  }
};
</script>
<style lang='less'>
.opera-aversion {
  .title {
    text-align: center;
    margin-top: 10px;
    h1 {
      margin: 20px auto 5px;
      font-size: 0.5rem;
    }
    h2 {
      font-size: 0.3rem;
      font-weight: normal;
      margin-top: 0;
      color: #999;
    }
    img {
      width: 54px;
      margin: 0 auto 5px;
    }
  }

  .tip {
    margin: 0 auto;
    width: 90%;
  }
  .tip li {
    line-height: 0.5rem;
    margin-top: 5px;
  }
  .tip .pic img {
    width: 80%;
    margin: 0 auto;
  }
  .ver {
    position: fixed;
    bottom: 10px;
    left: 0;
    width: 100%;
    text-align: center;
    img {
      width: 63px;
      height: 18px;
      margin: 0 auto;
    }
    div {
      font-size: 9px;
      color: #d7d7d7;
      margin-top: 8px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// versionDetail.vue?5956d69c